import { useEffect, useRef } from "react";
import { API } from "@/lib/api";

const seen = (key) => {
  try {
    if (sessionStorage.getItem(key)) return true;
    sessionStorage.setItem(key, "1");
  } catch { /* storage blocked */ }
  return false;
};

// Anonymous counters for paid highlights (no cookies, no personal data); counted once per browser session
export const trackAd = (eventId, kind) => {
  if (seen(`ad-${kind}-${eventId}`)) return;
  fetch(`${API}/promotions/track`, { method: "POST", keepalive: true, headers: { "Content-Type": "application/json" }, body: JSON.stringify({ event_id: eventId, kind }) }).catch(() => {});
};

export const adStats = (p) => `${p.impressions.toLocaleString("de-DE")} ${p.impressions === 1 ? "Einblendung" : "Einblendungen"} · ${p.clicks.toLocaleString("de-DE")} ${p.clicks === 1 ? "Klick" : "Klicks"}`;

export const useAdImpression = (ev) => {
  const ref = useRef(null);
  useEffect(() => {
    if (!ev.sponsored || !ref.current) return undefined;
    const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { trackAd(ev.id, "impression"); io.disconnect(); } }, { threshold: 0.5 });
    io.observe(ref.current);
    return () => io.disconnect();
  }, [ev.id, ev.sponsored]);
  return ref;
};
